import React, { useContext } from 'react'
import styled from '@emotion/styled'
import moment from 'moment'
import { colors } from 'style/theme'
import TimeAgo from 'react-timeago'
import { Button, Popover } from 'antd'
import { ProjectsContext } from 'views/UserManagement/Projects'

const StyledUsersPopoverContent = styled.div({
  minWidth: 200
})

const StyledRow = styled.div({
})

const StyledUser = styled.span({
  color: colors.brandText,
  fontWeight: 700,
  fontSize: 14,
  marginLeft: 20
})

const UsersPopoverContent = ({ users }) => {
  return (
    users && (
      <StyledUsersPopoverContent>
        {users.map((user, i) => {
          return (
            <StyledRow>
              <StyledUser>
                {user.name} {user.surname}
              </StyledUser>
            </StyledRow>
          )
        })}
      </StyledUsersPopoverContent>
    )
  )
}

const StyledCol = styled.span({
  fontWeight: 700,
  fontSize: 14
})

const StyledDate = styled(StyledCol)({
  color: colors.brandTextLight
})

const MoreCount = styled.div({
  backgroundColor: '#F4FAFF',
  border: `1px solid ${colors.brand}`,
  borderRadius: '50%',
  height: 24,
  width: 24,
  lineHeight: '24px',
  textAlign: 'center',
  color: colors.brand,
  fontSize: 10,
  margin: '0 auto'
})

function ProjectListColumns() {
  const { onEdit } = useContext(ProjectsContext)
  return [
    {
      title: 'NAME',
      dataIndex: 'name',
      width: '30%',
      sorter: (a, b) => a.name.localeCompare(b.name),
      render(name) {
        return <StyledCol>{name}</StyledCol>
      }
    },
    {
      title: 'USERS',
      dataIndex: 'users',
      sorter: (a, b) => a.users.length > b.users.length,
      align: 'center',
      render(users) {
        return (
          <Popover content={<UsersPopoverContent users={users} />}>
            <MoreCount>{users.length}</MoreCount>
          </Popover>
        )
      }
    },
    {
      title: 'LAST SCAN',
      dataIndex: 'last_scan_date',
      sorter: (a, b) => moment(a.last_scan_date).unix() - moment(b.last_scan_date).unix(),
      render(last_scan_date) {
        return (
          <StyledDate>
            <TimeAgo date={last_scan_date} />
          </StyledDate>
        )
      }
    },
    {
      title: 'CREATED',
      dataIndex: 'create_date',
      sorter: (a, b) => moment(a.create_date).unix() - moment(b.create_date).unix(),
      render(create_date) {
        return (
          <StyledDate>
            <TimeAgo date={create_date} />
          </StyledDate>
        )
      }
    },
    {
      key: 'edit',
      dataIndex: 'id',
      width: 100,
      render(id, project) {
        return (
          <Button type="link" icon="edit" onClick={() => onEdit(project)}>
            EDIT
          </Button>
        )
      }
    }
  ]
}

export default ProjectListColumns
